:host {
  display: block;
  margin-bottom: 20px;
}

.heading {
  background-color: var(--color-dark-gray);
  color: #fff;
  text-transform: uppercase;
  overflow-wrap: break-word;
  padding: 11px 22px;
}

.content {
  background-color: var(--color-off-white);
  padding: 20px;
}
::slotted(p) {
  margin-top: 0 !important;
}
::slotted(cwru-button) {
  margin-top: 20px !important;
}
